var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("MMP_DPR_SerialNumberChange", {
        attrs: { incomingData: _vm.incomingData, user: _vm.user },
        on: {
          updateSystems: function ($event) {
            return _vm.updateSystems($event)
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DPR_Decommission", {
        attrs: { incomingData: _vm.incomingData },
        on: {
          updateSystems: function ($event) {
            return _vm.updateSystems($event)
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DPR_UpdateVehicle", {
        attrs: { vehicle: _vm.vehicleToUpdate, user: _vm.user },
        on: {
          refresh: function ($event) {
            return _vm.getVehicles()
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DPR_DecommissionVehicle", {
        attrs: { vehicle: _vm.vehicleToDecommission, user: _vm.user },
        on: {
          refresh: function ($event) {
            return _vm.getVehicles()
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DPR_RecommissionVehicle", {
        attrs: { vehicle: _vm.vehicleToRecommission, user: _vm.user },
        on: {
          refresh: function ($event) {
            return _vm.getVehicles()
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DPR_NewVehicle", {
        attrs: { user: _vm.user },
        on: {
          refresh: function ($event) {
            return _vm.getVehicles()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "updatedNewSystemConfirmation",
            size: "md",
            "content-class": "sub-menu-bg-blue-transparent",
            title: "New System Confirmation",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "py-2" },
                [
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _vm.updateNewSystemForm.install_date
                        ? _c("b-col", [
                            _vm._v("\n            System '"),
                            _c("b", [
                              _vm._v(_vm._s(this.updateNewSystemForm.system)),
                            ]),
                            _vm._v("' with Scanner "),
                            _c("b", [
                              _vm._v(_vm._s(this.updateNewSystemForm.scanner)),
                            ]),
                            _vm._v(", Serial\n            Number '"),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  this.updateNewSystemForm.scannerSerialNumber
                                )
                              ),
                            ]),
                            _vm._v("', and Install Date of "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  this.updateNewSystemForm.install_date.toLocaleDateString(
                                    "en-US",
                                    {
                                      year: "numeric",
                                      month: "2-digit",
                                      day: "2-digit",
                                    }
                                  )
                                )
                              ),
                            ]),
                            _vm._v(
                              " will be added to the database.\n          "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "py-2" },
                    [
                      _c("b-col", [
                        _vm._v(
                          "\n            Click submit if these values are correct, or exit out of this\n            panel to make changes.\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "row-input py-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                size: "lg",
                                type: "submit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitUpdatedNewSystemForm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Confirm and Submit\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "adminConsoleModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal dpr-admin-modal",
            title: "Daily Productivity Report Admin Console",
            "hide-footer": "",
          },
          on: { show: _vm.loadAdminConsole },
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                {
                  attrs: { align: "center", pills: "", card: "" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "b-tab",
                    { attrs: { id: "operators", title: "Operators" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "pb-3",
                          attrs: { "align-v": "center", "align-h": "center" },
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: { checked: "true", switch: true },
                              on: {
                                change: function ($event) {
                                  return _vm.getOperators()
                                },
                              },
                              model: {
                                value: _vm.hideInactive,
                                callback: function ($$v) {
                                  _vm.hideInactive = $$v
                                },
                                expression: "hideInactive",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Hide Inactive Operators\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.newOperatorSuccess
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-3",
                              attrs: { id: "NewOperatorSuccessWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "alert alert-success" },
                                  [
                                    _c("b", [
                                      _vm._v(_vm._s(this.newOperatorSuccess)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.newOperatorSuccessHide()
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("vue-bootstrap4-table", {
                                attrs: {
                                  rows: _vm.operators,
                                  columns: _vm.operatorColumns,
                                  config: _vm.operatorConsoleConfig,
                                  actions: _vm.actions,
                                  classes: _vm.classes,
                                },
                                on: {
                                  newUser: function ($event) {
                                    return _vm.initNewUserModal()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "name",
                                    fn: function (props) {
                                      return [
                                        !props.row.update
                                          ? _c(
                                              "div",
                                              {
                                                class: {
                                                  inactive:
                                                    props.row.deleted_date,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.row.name)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "group",
                                    fn: function (props) {
                                      return [
                                        !props.row.update
                                          ? _c(
                                              "div",
                                              {
                                                class: {
                                                  inactive:
                                                    props.row.deleted_date,
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.row.group)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "deleted_date",
                                    fn: function (props) {
                                      return [
                                        props.row.deleted_date
                                          ? _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDateForDisplay(
                                                      props.row.deleted_date
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("span", [
                                                _c(
                                                  "small",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btn btn-warning btn-sm",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.reactivateOperator(
                                                              props.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Reactivate\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "update",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-blue",
                                            attrs: {
                                              disabled: props.row.deleted_date,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOperatorDetails(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("fa", {
                                              attrs: {
                                                icon: ["fas", "pencil-alt"],
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "delete",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-blue",
                                            attrs: {
                                              disabled: props.row.deleted_date,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteOperator(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("fa", {
                                              attrs: {
                                                icon: ["fas", "minus"],
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { id: "road-type", title: "Road Type" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "pb-3",
                          attrs: { "align-v": "center", "align-h": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "newRoadTypeInput",
                                  placeholder: "New Road Type",
                                },
                                model: {
                                  value: _vm.newRoadTypeInput,
                                  callback: function ($$v) {
                                    _vm.newRoadTypeInput = $$v
                                  },
                                  expression: "newRoadTypeInput",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "success" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.newRoadType()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Add\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.newRoadTypeSuccess
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-3",
                              attrs: { id: "NewRoadTypeSuccessWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "alert alert-success" },
                                  [
                                    _c("b", [
                                      _vm._v(_vm._s(this.newRoadTypeSuccess)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.newRoadTypeSuccessHide()
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.updateRoadTypeSuccess
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-3",
                              attrs: { id: "UpdateRoadTypeSuccessWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "alert alert-success" },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(this.updateRoadTypeSuccess)
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateRoadTypeSuccessHide()
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.deleteRoadTypeSuccess
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-3",
                              attrs: { id: "DeleteRoadTypeSuccessWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "alert alert-success" },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(this.deleteRoadTypeSuccess)
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteRoadTypeSuccessHide()
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("vue-bootstrap4-table", {
                                attrs: {
                                  rows: _vm.roadTypes,
                                  columns: _vm.roadTypeColumns,
                                  config: _vm.roadTypeConsoleConfig,
                                  classes: _vm.classes,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "type",
                                    fn: function (props) {
                                      return [
                                        !props.row.update
                                          ? _c("div", [
                                              _c("span", [
                                                _vm._v(_vm._s(props.row.type)),
                                              ]),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        props.row.update
                                          ? _c(
                                              "div",
                                              [
                                                _c("b-form-input", {
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value: props.row.type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        props.row,
                                                        "type",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "props.row.type",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-success pt-1",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.changeRoadTypeName(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("fa", {
                                                      attrs: {
                                                        icon: ["fas", "check"],
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger pt-1",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.cancelChangeRoadTypeName(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("fa", {
                                                      attrs: {
                                                        icon: ["fas", "times"],
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "update",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-blue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateRoadType(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("fa", {
                                              attrs: {
                                                icon: ["fas", "pencil-alt"],
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "delete",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-blue",
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteRoadType(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("fa", {
                                              attrs: {
                                                icon: ["fas", "minus"],
                                                size: "lg",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { id: "new-system", title: "New System" } },
                    [
                      _c(
                        "b-container",
                        { staticClass: "new-form-container" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                System Name\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.updateNewSystemForm.system,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "system",
                                          $$v
                                        )
                                      },
                                      expression: "updateNewSystemForm.system",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                System Type\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.systemTypeOptions },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-form-select-option",
                                              {
                                                attrs: {
                                                  value: null,
                                                  disabled: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Select System Type\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.updateNewSystemForm.system_type,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "system_type",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "updateNewSystemForm.system_type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                Scanner\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      number: "",
                                      min: "0",
                                      max: "2",
                                    },
                                    model: {
                                      value: _vm.updateNewSystemForm.scanner,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "scanner",
                                          $$v
                                        )
                                      },
                                      expression: "updateNewSystemForm.scanner",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                Scanner Serial Number\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value:
                                        _vm.updateNewSystemForm
                                          .scannerSerialNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "scannerSerialNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "updateNewSystemForm.scannerSerialNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                Region\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.regionOptions },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "first",
                                        fn: function () {
                                          return [
                                            _c(
                                              "b-form-select-option",
                                              {
                                                attrs: {
                                                  value: null,
                                                  disabled: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Select Region\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.updateNewSystemForm.region,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "region",
                                          $$v
                                        )
                                      },
                                      expression: "updateNewSystemForm.region",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "row-input py-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "row-label-right-justify",
                                  attrs: { "align-self": "center" },
                                },
                                [
                                  _vm._v(
                                    "\n                Install Date\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("b-form-datepicker", {
                                    attrs: {
                                      locale: "en",
                                      placeholder: "MM/DD/YYYY",
                                      "value-as-date": true,
                                      "date-format-options": {
                                        month: "2-digit",
                                        day: "2-digit",
                                        year: "numeric",
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.updateNewSystemForm.install_date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.updateNewSystemForm,
                                          "install_date",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "updateNewSystemForm.install_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "submit py-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        size: "lg",
                                        type: "submit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showUpdatedNewSystemConfirmation()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Submit\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { title: "Vehicles" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            !this.dataLoaded
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center py-1",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-md highlightLoader",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "highlightLoader p-1 spinner-border-md",
                                      },
                                      [_vm._v("Loading Data...")]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tableHeader" },
                                      [
                                        _c(
                                          "b-form-checkbox-group",
                                          {
                                            staticClass: "checkboxes",
                                            model: {
                                              value:
                                                _vm.vehiclesSelectedRegions,
                                              callback: function ($$v) {
                                                _vm.vehiclesSelectedRegions =
                                                  $$v
                                              },
                                              expression:
                                                "vehiclesSelectedRegions",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                staticClass: "custom-checkbox",
                                                attrs: {
                                                  size: "lg",
                                                  value: "North America",
                                                },
                                              },
                                              [_vm._v("NA")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Europe",
                                                },
                                              },
                                              [_vm._v("EU")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "South Korea",
                                                },
                                              },
                                              [_vm._v("SK")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Japan",
                                                },
                                              },
                                              [_vm._v("JP")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Middle East",
                                                },
                                              },
                                              [_vm._v("ME")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mm-field" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "vehicles-status-toggle",
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "vehicle-toggle-indicator",
                                                style: {
                                                  transform: `translateX(${
                                                    _vm.activeVehicleFlag
                                                      ? 0
                                                      : 100
                                                  }%)`,
                                                  background: "#007bff",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "vehicle-toggle-btn white-text",
                                                  class: {
                                                    active:
                                                      _vm.activeVehicleFlag,
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.activeVehicleFlag = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Active\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "vehicle-toggle-btn white-text",
                                                  class: {
                                                    active:
                                                      !_vm.activeVehicleFlag,
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.activeVehicleFlag = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Inactive\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("vue-bootstrap4-table", {
                                      attrs: {
                                        rows: _vm.filteredVehicles,
                                        columns: _vm.activeVehicleFlag
                                          ? _vm.activeVehiclesColumns
                                          : _vm.inactiveVehiclesColumns,
                                        config: _vm.systemConsoleConfig,
                                        classes: _vm.classes,
                                        actions: _vm.vehiclesActions,
                                      },
                                      on: {
                                        newVehicle: function ($event) {
                                          return _vm.$bvModal.show(
                                            "newVehicleModal"
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "vehicle_name",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.vehicle_name
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "region",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.row.region)
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "updated_user",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.updated_user
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "decommissioned_date",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        new Date(
                                                          props.row.decommissioned_date
                                                        ).toLocaleDateString(
                                                          _vm.language,
                                                          {
                                                            month: "2-digit",
                                                            day: "2-digit",
                                                            year: "numeric",
                                                          }
                                                        ) +
                                                          " , " +
                                                          new Date(
                                                            props.row.decommissioned_date
                                                          ).toLocaleTimeString(
                                                            _vm.language,
                                                            {
                                                              hour: "2-digit",
                                                              minute: "2-digit",
                                                            }
                                                          )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "updated_date",
                                          fn: function (props) {
                                            return [
                                              props.row.updated_date
                                                ? _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            new Date(
                                                              props.row.updated_date
                                                            ).toLocaleDateString(
                                                              _vm.language,
                                                              {
                                                                month:
                                                                  "2-digit",
                                                                day: "2-digit",
                                                                year: "numeric",
                                                              }
                                                            ) +
                                                              " , " +
                                                              new Date(
                                                                props.row.updated_date
                                                              ).toLocaleTimeString(
                                                                _vm.language,
                                                                {
                                                                  hour: "2-digit",
                                                                  minute:
                                                                    "2-digit",
                                                                }
                                                              )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "update",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btn-blue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateVehicle(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        "pencil-alt",
                                                      ],
                                                      size: "lg",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "decommission",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btn-blue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.decommissionVehicle(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: ["fas", "trash"],
                                                      size: "lg",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "recommission",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn btn-success",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.recommissionVehicle(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: ["fas", "redo"],
                                                      size: "lg",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    { attrs: { id: "systems", title: "Systems" } },
                    [
                      _vm.newSystemSuccess
                        ? _c(
                            "b-row",
                            {
                              staticClass: "p-3",
                              attrs: { id: "NewSystemSuccessWindow" },
                            },
                            [
                              _c("b-col", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  { staticClass: "alert alert-success" },
                                  [
                                    _c(
                                      "b",
                                      {
                                        staticStyle: { "text-shadow": "none" },
                                      },
                                      [_vm._v(_vm._s(this.newSystemSuccess))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.newSystemSuccessHide()
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "window-close"] },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            !this.dataLoaded
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center py-1",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-md highlightLoader",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "highlightLoader p-1 spinner-border-md",
                                      },
                                      [_vm._v("Loading Data...")]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tableHeader" },
                                      [
                                        _c(
                                          "b-form-checkbox-group",
                                          {
                                            staticClass: "checkboxes",
                                            model: {
                                              value: _vm.systemsSelectedRegions,
                                              callback: function ($$v) {
                                                _vm.systemsSelectedRegions = $$v
                                              },
                                              expression:
                                                "systemsSelectedRegions",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                staticClass: "custom-checkbox",
                                                attrs: {
                                                  size: "lg",
                                                  value: "North America",
                                                },
                                              },
                                              [_vm._v("NA")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Europe",
                                                },
                                              },
                                              [_vm._v("EU")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Japan",
                                                },
                                              },
                                              [_vm._v("JP")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  size: "lg",
                                                  value: "Middle East",
                                                },
                                              },
                                              [_vm._v("ME")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "mm-field" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "vehicles-status-toggle",
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "vehicle-toggle-indicator",
                                                style: {
                                                  transform: `translateX(${
                                                    _vm.activeSystemFlag
                                                      ? 0
                                                      : 100
                                                  }%)`,
                                                  background: "#007bff",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "vehicle-toggle-btn white-text",
                                                  class: {
                                                    active:
                                                      _vm.activeSystemFlag,
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.activeSystemFlag = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Active\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "vehicle-toggle-btn white-text",
                                                  class: {
                                                    active:
                                                      !_vm.activeSystemFlag,
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.activeSystemFlag = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        History\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("vue-bootstrap4-table", {
                                      attrs: {
                                        rows: _vm.filteredSystems,
                                        columns: _vm.activeSystemFlag
                                          ? _vm.systemColumns
                                          : _vm.systemHistoryColumns,
                                        config: _vm.systemConsoleConfig,
                                        classes: _vm.classes,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "system",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.row.system)
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "serial_number",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.serial_number
                                                    )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "install_date",
                                          fn: function (props) {
                                            return [
                                              props.row.install_date
                                                ? _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          new Date(
                                                            props.row.install_date
                                                          ).toLocaleDateString(
                                                            "en-US",
                                                            {
                                                              year: "numeric",
                                                              month: "2-digit",
                                                              day: "2-digit",
                                                            }
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "region",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.row.region)
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "decommission_date",
                                          fn: function (props) {
                                            return [
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        new Date(
                                                          props.row.decommission_date
                                                        ).toLocaleString(
                                                          "en-US",
                                                          {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                          }
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "update",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btn-blue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.changeSerialNumber(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        "pencil-alt",
                                                      ],
                                                      size: "lg",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "decommission",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn btn-blue",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.decommissionSystem(
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("fa", {
                                                    attrs: {
                                                      icon: ["fas", "trash"],
                                                      size: "lg",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }